export default function GoogleMapsService(
    $document,
    uiGmapGoogleMapApi
) {
    'ngInject';

    let googleMaps = null;
    let placesAutocompleteService = null;
    let placesService = null;
    let placesServiceStatuses = null;

    return {
        loadGoogleMaps,
        getPlacesAutocompleteService,
        getPlacesService,
        getPlacesServiceStatuses,
        getGoogleMaps,
    };

    function loadGoogleMaps() {
        uiGmapGoogleMapApi
            .then((maps) => {
                googleMaps = maps;
                placesAutocompleteService = new maps.places.AutocompleteService();
                placesService = new maps.places.PlacesService(document.createElement('div'));
                placesServiceStatuses = maps.places.PlacesServiceStatus;
            });
    }

    function getGoogleMaps() {
        return googleMaps;
    }

    function getPlacesAutocompleteService() {
        return placesAutocompleteService;
    }

    function getPlacesService() {
        return placesService;
    }

    function getPlacesServiceStatuses() {
        return placesServiceStatuses;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/google-maps-service/google-maps-service.js